import { connect } from 'react-redux';
import Antecipacao from './antecipacao';

export default connect()(Antecipacao);
